module.exports = require("lodash/minBy");